import gql from 'graphql-tag';

export const addHistorie = gql`
  mutation addHistorie($input: [HistorieInput!]!) {
    response: addHistorie(inputHistorie: $input) {
      id
    }
  }
`;
